var map = {
	"./additionalInfoIcon.svg": 531,
	"./arrowLeftIcon.svg": 532,
	"./arrowMediumTop.svg": 533,
	"./arrowRightIcon.svg": 534,
	"./arrowRightIconSharp.svg": 535,
	"./arrowRightSmallIcon.svg": 536,
	"./arrowScalableIcon.svg": 537,
	"./arrowSelect2.svg": 538,
	"./arrowSelectIcon.svg": 539,
	"./benefit1.svg": 540,
	"./benefit2.svg": 541,
	"./benefit3.svg": 542,
	"./cardsIcon.svg": 543,
	"./checkCirсleIcon.svg": 544,
	"./circleInfoIcon.svg": 545,
	"./copyIcon copy.svg": 546,
	"./copyIcon.svg": 547,
	"./crossIcon.svg": 548,
	"./crossIcon2.svg": 549,
	"./crossIcon3.svg": 550,
	"./crossIconSmall.svg": 551,
	"./crossSmallIcon.svg": 552,
	"./defaultCategoryIcon.svg": 553,
	"./depNumberIcon.svg": 554,
	"./elfCentralIcon.svg": 555,
	"./equalitySign.svg": 556,
	"./errorIcon.svg": 442,
	"./eyeClosedIcon.svg": 557,
	"./eyeOpenIcon.svg": 558,
	"./favoritesIcon.svg": 559,
	"./favoritesLabelIcon.svg": 560,
	"./filterDivider.svg": 561,
	"./filterIcon.svg": 562,
	"./frequencyIcon.svg": 563,
	"./fsAmountIcon.svg": 564,
	"./fullScreenIcon.svg": 565,
	"./gameIcon.svg": 566,
	"./goldGiftIcon.svg": 567,
	"./hamburgerIcon.svg": 568,
	"./infoIcon.svg": 569,
	"./infoSymbol.svg": 570,
	"./levelBackground.svg": 571,
	"./levelBackgroundNew.svg": 572,
	"./linkIcon.svg": 573,
	"./lockIcon.svg": 574,
	"./lockSharpIcon.svg": 575,
	"./maxBonusAmountIcon.svg": 576,
	"./maxWinFsIcon.svg": 577,
	"./menuIcon.svg": 578,
	"./minDepIcon.svg": 579,
	"./noTournamentIcon.svg": 580,
	"./playIcon.svg": 581,
	"./polygon.svg": 582,
	"./preloaderDotsAnimation.svg": 583,
	"./preloaderSpinnerAnimation.svg": 584,
	"./presentIcon.svg": 585,
	"./promoIcon.svg": 586,
	"./recentIcon.svg": 587,
	"./search2Icon.svg": 588,
	"./search3Icon.svg": 589,
	"./sharpTickIcon copy.svg": 590,
	"./sharpTickIcon.svg": 591,
	"./smallInfoSymbol.svg": 592,
	"./smoothArrowIcon.svg": 593,
	"./successIcon.svg": 594,
	"./supportIcon.svg": 595,
	"./tag1Icon.svg": 596,
	"./tag2Icon.svg": 597,
	"./tag3Icon.svg": 598,
	"./tag4Icon.svg": 599,
	"./tickIcon.svg": 600,
	"./unverified.svg": 601,
	"./verified.svg": 602,
	"./wagerIcon.svg": 603,
	"./wagerTimeIcon.svg": 604,
	"./warningIcon.svg": 605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 530;